export enum ETipoCadernoJornal {
  DiarioDoExecutivo = 1,
  DiarioDosMunicipiosMineiros = 2,
  DiarioDeTerceiros = 3,
  EdicaoExtra = 4
}

const titulosCadernosEdicaoExtra: Readonly<Partial<Record<ETipoCadernoJornal, string>>> = {
  [ETipoCadernoJornal.DiarioDoExecutivo]: 'Edição Extra Executivo',
  [ETipoCadernoJornal.DiarioDosMunicipiosMineiros]: 'Edição Extra Municípios Mineiros',
  [ETipoCadernoJornal.DiarioDeTerceiros]: 'Edição Extra Terceiros'
};

export function obterTituloCadernoEdicaoExtra(tipoCaderno: number, nomeCaderno: string): string {
  return titulosCadernosEdicaoExtra[tipoCaderno as ETipoCadernoJornal]
    ?? `Edição Extra ${nomeCaderno}`;
}